export const toFixed = (value, precision = 0) => (Math.round(+value * 100) / 100).toFixed(precision);

export const range = (n) => Array(...Array(n)).map((_, i) => i);
